import { ReactNode } from "react";

export interface UICollapseProps {
    in: boolean;
    children?: ReactNode;
}

export function UICollapse(props: UICollapseProps) {
    return <>{props.in && props.children}</>;
}
